module.exports = __webpack_public_path__ + "static/media/image_2-min.b0119394.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/image_2-min.jpg
// module id = 1081
// module chunks = 0